import VueRouter, { Route } from 'vue-router'
import Observable from 'zen-observable'

declare global {
  interface Window {
    kiwi: any;
  }
}

export interface VFS {
  ReadDir(path: string): Promise<FileInfo[]>;
  // Path musi by cesta k soubru, jinak vraci chybu
  ResolveFilename(path: string): Promise<string>;
  Stat(path: string): Promise<FileInfo>;
}

export interface FileInfo {
  Name: string;
  IsDir: boolean;
  ContentType: string;
  XAttr?: { [key: string]: string };
}

export interface MountPoint {
  vfs: VFS;
  // Vstupem je správně za enkodovaná cesta
  path: string;
}

export type Views = { [name: string]: View }

export type PatternView = { [pattern: string]: Views }

export interface View {
  Component(): Promise<any>;
  Config(): Promise<ViewConfig>;
}

export type ViewConfig = { [prop: string]: string }

export interface VirtualView {
  Components(path: string): { [name: string]: View };
}

export interface PathController {
  push(path: string): void;
  replace(path: string): void;
  path(): string;
  // resolve(path: string): string;
  resolve(file: FileInfo): Location;
  back(): void;
  forward(): void;
}

export interface Location {
  href: string;
  path: string;
}

export class VuePathController implements PathController {
  private vueRouter: VueRouter

  constructor (vueRouter: VueRouter) {
    this.vueRouter = vueRouter
  }

  back (): void {
    this.vueRouter.go(-1)
  }

  forward (): void {
    this.vueRouter.go(1)
  }

  push (path: string): void {
    this.vueRouter.push(path)
  }

  replace (path: string): void {
    this.vueRouter.replace(path)
  }

  path (): string {
    return this.vueRouter.currentRoute.path
  }

  resolve (file: FileInfo): Location {
    if (file.IsDir) {
      const r = this.vueRouter.resolve(`${file.Name}/`)
      return {
        href: r.href,
        path: r.resolved.path
      }
    }
    const r = this.vueRouter.resolve(file.Name)
    return {
      href: r.href,
      path: r.resolved.path
    }
  }
}

export class KiwiBarcodeController<T> implements EventSubscription {
  private observable: Observable<T>
  constructor () {
    this.observable = new Observable((observer) => {
      const { kiwi } = window
      if (kiwi) {
        kiwi.on('barcodescanned', (code: any) => {
          observer.next(code)
        })
      }
    })
  }

  subscribe (onNext: (value: unknown) => void, onError?: (error: any) => void, onComplete?: () => void): ZenObservable.Subscription {
    return this.observable.subscribe({
      complete: onComplete,
      error: onError,
      next: onError
    })
  }
}

export interface EventSubscription {
  subscribe(
    onNext: (value: unknown) => void,
    onError?: (error: any) => void,
    onComplete?: () => void,
  ): ZenObservable.Subscription;
}
